<template>
  <b-form-group
    label="Gelir Tarihi"
    label-for="ddate"
  >
    <b-form-datepicker
      id="ddate"
      v-model="dataItem.ddate"
      v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
      locale="tr"
      start-weekday="1"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormDatepicker,
} from 'bootstrap-vue'

export default {
  name: 'DonationGroups',
  components: {
    BFormGroup,
    BFormDatepicker,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
